import { AxiosInstance } from 'axios';
import authHeader from './auth_header';
import axiosInstance from "./axios_instance";

const ApiPath = "/api/settlements";

class SettlementService {
    private instance: AxiosInstance;
    private readonly navigate: any;

    constructor(navigate: any) {
        this.instance = axiosInstance(navigate);
        this.navigate = navigate;
    }

    async inquiry(params: any) {
        const headers = authHeader(this.navigate);
        return await this.instance.get(ApiPath, { headers, params });
    }

    async download(params: any) {
        const headers = authHeader(this.navigate);
        return await this.instance.get(ApiPath + '/download', { headers, params, responseType: 'blob' });
    }
}

export default SettlementService;